
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  *
  * The source file is located at:
  *   /codebuild/output/src1738611268/src/vl-app/pages/index.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
const Home = () => {
  window?.location.replace('/login');

  return null;
};


export const Route = createFileRoute('/')({ component: Home });
